import React, { useMemo } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { Icon, Tooltip } from "antd";

import { CourseWareTypeList } from "../../../../../utils/common";

interface FileListProps {
    fileName: string; //文件名
    fileSize?: string; //文件大小
    uploaderName?: string; //上传人姓名
    isPreview?: boolean; //是否可以预览或下载
    onDelete?: () => void; //删除
    onDownload?: () => void; //下载
    onPrev?: () => void; //预览
    fileStyle?: React.CSSProperties;
    maxNameWidth?: number;
}

export default function FileList({
    fileName,
    fileSize,
    uploaderName,
    isPreview = true,
    onDelete,
    onDownload,
    onPrev,
    fileStyle,
    maxNameWidth
}: FileListProps) {
    type keyType = keyof typeof CourseWareTypeList;
    const suffixName = fileName.split(".").pop();
    const fileType = useMemo((): string => {
        for (let type of Object.keys(CourseWareTypeList)) {
            if (
                suffixName &&
                CourseWareTypeList[type as keyType].includes(
                    suffixName.toLowerCase()
                )
            ) {
                return type;
            }
        }
        return "";
    }, [fileName]);

    return (
        <div
            className={classNames(style.file, style[fileType])}
            style={fileStyle}>
            <h1>
                <Tooltip title={fileName} placement="topLeft">
                    <span
                        className={style.fileName}
                        style={{ maxWidth: maxNameWidth }}>
                        {fileName}
                    </span>
                </Tooltip>
                <span className={style.fileSize}>
                    大小 {fileSize}&nbsp;&nbsp;
                    {uploaderName && (
                        <Tooltip title={uploaderName} placement="topLeft">
                            <span className={style.uploaderName}>
                                | &nbsp;&nbsp;上传人 {uploaderName}
                            </span>
                        </Tooltip>
                    )}
                </span>
            </h1>

            <h1 className={style.btns}>
                {isPreview && (
                    <>
                        <img
                            src={require("./img/download.png")}
                            alt=""
                            onClick={onDownload}
                        />
                        <img
                            src={require("./img/preview.png")}
                            alt=""
                            onClick={onPrev}
                        />
                    </>
                )}
                {!isPreview && (
                    <span className={style.opacity} onClick={onDelete}>
                        <Icon type="close" />
                    </span>
                )}
            </h1>
        </div>
    );
}
